import React, { useCallback, useEffect, useState } from 'react';

import {
  CloudEnvironmentType,
  EnvironmentRead,
} from '@ariksa/compliance-policies/api';
import { CloudInsightCategory } from '@ariksa/inventory-core/api';
import { Center, HStack, Text } from '@chakra-ui/react';
import { map } from 'lodash';

import { BusinessCriticalIcon } from 'components/Icons';
import { useEnvironmentOptions } from 'containers/App/hooks/useEnvironmentOptions';
import { limitedString } from 'utils/string';

interface EnvironmentNameProps {
  environmentId: string;
  limitedStringNumber?: number;
}

export const EnvironmentName = (props: EnvironmentNameProps) => {
  const { environmentMapping } = useEnvironmentOptions();
  const { environmentId, limitedStringNumber } = props;
  const [env, setEnv] = useState<EnvironmentRead>({} as EnvironmentRead);

  useEffect(() => {
    setEnv(environmentMapping?.[environmentId] ?? ({} as EnvironmentRead));
  }, [environmentId, environmentMapping]);

  return (
    <HStack w="full" spacing={1}>
      {env?.is_business_critical && (
        <Center boxSize={7}>
          <BusinessCriticalIcon />
        </Center>
      )}
      <Text
        overflow="hidden"
        whiteSpace="nowrap"
        textOverflow="ellipsis"
        w="full"
      >
        {limitedStringNumber
          ? limitedString(env?.name ?? environmentId, limitedStringNumber)
          : env?.name ?? environmentId}
      </Text>
    </HStack>
  );
};

export const useShowEnvironment = () => {
  // filtering environments based on the current path
  const showEnvironment = useCallback(
    (environment: EnvironmentRead, pathname) => {
      if (pathname.includes('/inventory')) {
        return true;
      }

      if (pathname.includes('/findings')) {
        return (
          environment.environment_type === CloudEnvironmentType.CloudProvider ||
          environment.environment_type === CloudEnvironmentType.IdentityProvider
        );
      }

      if (
        pathname.includes('/visibility/access') ||
        pathname.includes('/visibility/posture') ||
        pathname.includes('/dashboard/data')
      ) {
        return (
          environment.environment_type === CloudEnvironmentType.CloudProvider
        );
      } else if (pathname.includes('/dashboard')) {
        return (
          environment.environment_type === CloudEnvironmentType.Iac ||
          environment.environment_type === CloudEnvironmentType.CloudProvider
        );
      }

      return (
        environment.environment_type === CloudEnvironmentType.CloudProvider
      );
    },
    [],
  );

  return {
    showEnvironment,
  };
};

export const runtimeInsightsCategoryOptions = map(CloudInsightCategory, o => ({
  label: o,
  value: o,
}));
